module.exports = __webpack_public_path__ + "static/img/user-avatar.e147bdeb.png";